
  (function ($) {
    $.fn.extend({
      rotaterator: function (options) {
        var defaults = {
          fadeSpeed: 500,
          pauseSpeed: 2000,
          child: null
        };

        var options = $.extend(defaults, options);

        return this.each(function () {
          var o = options;
          var obj = $(this);
          var items = $(obj.children(), obj);
          items.each(function () {
            $(this).hide();
          });
          if (!o.child) {
            var next = $(obj).children(":first");
          } else {
            var next = o.child;
          }
          $(next).fadeIn(o.fadeSpeed, function () {
            $(next)
              .delay(o.pauseSpeed)
              .fadeOut(o.fadeSpeed, function () {
                var next = $(this).next();
                if (next.length == 0) {
                  next = $(obj).children(":first");
                }
                $(obj).rotaterator({
                  child: next,
                  fadeSpeed: o.fadeSpeed,
                  pauseSpeed: o.pauseSpeed
                });
              });
          });
        });
      }
    });
  })(jQuery);

  $(document).ready(function () {
    $("#rotate").rotaterator({ fadeSpeed: 500, pauseSpeed: 2000 });
  });



const scrollContainer = document.getElementById("vidCardScroll");
const scrollLeft = document.getElementById("scrollLeft");
const scrollRight = document.getElementById("scrollRight");

// Dynamically get the width of a single vid-card
function getCardWidth() {
  const card = scrollContainer.querySelector(".vid-card");
  return card ? card.offsetWidth + parseInt(getComputedStyle(card).marginRight) : 300;
}

function updateNavButtons() {
  scrollLeft.disabled = scrollContainer.scrollLeft <= 0;
  scrollRight.disabled = scrollContainer.scrollLeft + scrollContainer.offsetWidth >= scrollContainer.scrollWidth - 5;
}

// Initial check
updateNavButtons();
window.addEventListener("resize", updateNavButtons);
scrollContainer.addEventListener("scroll", updateNavButtons);

// Scroll events
scrollLeft.addEventListener("click", () => {
  scrollContainer.scrollBy({ left: -getCardWidth(), behavior: "smooth" });
});
scrollRight.addEventListener("click", () => {
  scrollContainer.scrollBy({ left: getCardWidth(), behavior: "smooth" });
});


  // Initial check
  updateNavButtons();

  // Re-check on scroll
  scrollContainer.addEventListener("scroll", updateNavButtons);

  // Scroll event for Left button
  scrollLeft.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
  });

  // Scroll event for Right button
  scrollRight.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
  });



const stickyBar = document.getElementById('sticky-offer');
const shopifyHeader = document.querySelector('.header');
const marqueeBanner = document.querySelector('.custom-marquee-banner'); // ← Add this line

window.addEventListener('scroll', () => {
  const scrollY = window.scrollY;

  if (scrollY > 400) {
    stickyBar?.classList.add('show');
    shopifyHeader?.classList.add('hidden');
    marqueeBanner?.classList.add('hidden'); // ← Hide the marquee too
  } else {
    stickyBar?.classList.remove('show');
    shopifyHeader?.classList.remove('hidden');
    marqueeBanner?.classList.remove('hidden'); // ← Show it again
  }
});





 let hasInteracted = false;

  const layerButtons = document.querySelectorAll(".layer-btn");
  const layerTexts = document.querySelectorAll(".layer-text");
  const layerDetails = document.querySelector(".layer-details");

  function activateLayer(layer) {
    // Sync buttons
    layerButtons.forEach((b) => {
      b.classList.toggle("active", b.dataset.layer === layer);
    });

    // Sync desktop text
    layerTexts.forEach((t) => {
      t.classList.toggle("active", t.dataset.layer === layer);
    });

    // Scroll desktop text into view only if user has interacted
    const activeText = document.querySelector(
      `.layer-text[data-layer="${layer}"]`
    );
    if (activeText && window.innerWidth > 975 && hasInteracted) {
      activeText.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    // On mobile: scroll to matching slide
    if (
      window.innerWidth <= 975 &&
      $(".mobile-layer-slider").hasClass("slick-initialized")
    ) {
      const $slides = $(".mobile-layer-slider .mobile-slide");
      const index = $slides
        .toArray()
        .findIndex((slide) => slide.dataset.layer === layer);
      if (index !== -1) {
        $(".mobile-layer-slider").slick("slickGoTo", index);
      }
    }
  }

  // Track interaction from buttons
  layerButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      hasInteracted = true;
      activateLayer(btn.dataset.layer);
    });
  });

  // Track interaction from text blocks
  layerTexts.forEach((text) => {
    text.addEventListener("click", () => {
      hasInteracted = true;
      activateLayer(text.dataset.layer);
    });
  });

  // Initialize Slick slider and default layer
  $(document).ready(function () {
    if (window.innerWidth <= 975) {
      $(".mobile-layer-slider").slick({
        centerMode: true,
        centerPadding: "50px",
        slidesToShow: 1,
        arrows: false,
        dots: false,
        infinite: false,
        variableWidth: false,
      });

      $(".mobile-layer-slider").on(
        "afterChange",
        function (e, slick, currentSlide) {
          const layer = $(".mobile-slide")
            .eq(currentSlide)
            .data("layer")
            .toString();
          activateLayer(layer);
        }
      );
    }

    // Activate default layer without scrolling
    activateLayer("1");
  });



